import { Component, OnInit } from '@angular/core';
import { BaseIcon } from '../base-icon';

@Component({
	selector: 'app-icon-companies',
	templateUrl: './icon-companies.component.html',
	styleUrls: ['./icon-companies.component.scss'],
})
export class IconCompaniesComponent extends BaseIcon implements OnInit {
	constructor() {
        super()
    }

	ngOnInit() {}
}
